class VisualMenu extends HTMLElement {
  constructor() {
    super();

    this.categories = this.querySelector('#visual-menu-categories');
    this.buttonPrev = this.querySelector('.visual-menu-slider-button-hover[name="previous"]');
    this.buttonNext = this.querySelector('.visual-menu-slider-button-hover[name="next"]');

    this.buttonPrev.addEventListener('click', this.visualMenuScrollLeft.bind(this));
    this.buttonNext.addEventListener('click', this.visualMenuScrollRight.bind(this));
  }

  visualMenuScrollLeft() {
    if (this.categories.scrollLeft > 0) {
      this.categories.scrollLeft -= 250;
    }
  }

  visualMenuScrollRight() {
    const scrollLeft = this.categories.scrollLeft + 250;

    if (scrollLeft < this.categories.scrollWidth) {
      this.categories.scrollLeft += 250;
    }
  }
}

customElements.define('visual-menu', VisualMenu);
